import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './RelatorioAuditoriaGenerico.css';
import DatePicker , { registerLocale }from "react-datepicker";
import pt_br from "date-fns/locale/pt-BR";
import "react-datepicker/dist/react-datepicker.css";
import { Resultado } from "./Resultado";
import { baixarArquivo } from "../../utils/downloadUtil";

registerLocale("pt_br", pt_br);

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

const tipoVisaoConsumidor = 'C';
const tipoVisaoFornecedor = 'F';
const tipoVisaoOperador = 'O';
const tipoVisaoPontoFocal = 'P';

export const RelatorioAuditoriaGenerico =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);

			this.initialState = {
				orgaos: [],
				orgao: '',
				consumidoras: [],
				consumidorasOrgao: [],
				consumidora: '',
				fornecedoras: [],
				fornecedora: '',
				exibeColunaCpfsCnpj: false,
				carregarCodigosBilhetados: false,
				carregandoConsumidoras: false,
				carregandoFornecedoras: false,
				relatorioAuditoriaGenerico: {},
				periodoInicial: '',
				periodoFinal: '',
				tiposVisao: [],
				tipoVisao: tipoVisaoConsumidor,
				bilhetados: true,
				codigosBilhetados: [],
				pesquisaExecutada : false,
				botoesHabilitados : true,
			};
			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleAPIChange = this.handleAPIChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.carregarOrgaos = this.carregarOrgaos.bind(this);
			this.carregarConsumidoras = this.carregarConsumidoras.bind(this);
			this.carregarFornecedoras = this.carregarFornecedoras.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisa = this.executaPesquisa.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.mostraRelatorioAuditoriaGenericoPDF = this.mostraRelatorioAuditoriaGenericoPDF.bind(this);
			this.mostraRelatorioAuditoriaGenericoCSV = this.mostraRelatorioAuditoriaGenericoCSV.bind(this);
			this.handleTipoVisaoChange = this.handleTipoVisaoChange.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Relatório de auditoria</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			let tipoVisao = this.state.tipoVisao;
			if(this.props.user.isFornecedor === true || this.props.user.isOperador === true){
				tipoVisao = tipoVisaoFornecedor;
				if(this.props.user.isOperador === true ){
					tipoVisao = tipoVisaoOperador;
				}

				api.get('/api/consumo/tipos-visao-relatorio')
				.then(response => { 
					const tiposVisao = response.data.filter(tv => tv.codigo !== tipoVisaoPontoFocal);
					this.setState({
						tipoVisao,
						tiposVisao,
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os tipos de visão para o relatório " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}

			this.carregarOrgaos(tipoVisao);

			if(this.props.user.isCliente === true){
				api.get('/api/aplicacao-consumidora/orgao')
				.then(response => { 
					const consumidoras = response.data;
					this.setState(
						{
							consumidoras,
							consumidorasOrgao: [...consumidoras]
						}
					) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar as aplicações do órgão " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});
			}

			this.carregarFornecedoras(tipoVisao, this.state.orgao);

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { relatorioAuditoriaGenerico, pesquisaExecutada, exibeColunaCpfsCnpj } = this.state;
			const user = this.props.user;
			const tipoVisao = this.state.tipoVisao;
			const exibeComboOrgao = user && (user.isAdministrador === true || user.isMantenedor === true || (user.isFornecedor === true && tipoVisao === tipoVisaoFornecedor) || (user.isOperador === true && tipoVisao === tipoVisaoOperador));
			const exibeComboAplicacao = ((user.isCliente === true && tipoVisao === tipoVisaoConsumidor) || ((user.isAdministrador === true || user.isMantenedor === true || (user.isFornecedor === true && tipoVisao === tipoVisaoFornecedor)|| (user.isOperador === true && tipoVisao === tipoVisaoOperador)) && this.state.orgao !== ''));
			const exibeBotoes = relatorioAuditoriaGenerico.content && relatorioAuditoriaGenerico.content.length > 0;
			const codigosBilhetados = this.state.codigosBilhetados.length > 0 ? "(" + this.state.codigosBilhetados.toString() + ")" : "";

			return(
				<div className="container-fluid">
					<div className="br-form">
						{user && (user.isFornecedor === true || user.isOperador === true) &&
							<div className="row">
								<div className="col-sm-2">
									<div className="field">
										<div className="input">
											<label htmlFor="tipoVisao">Mostrar:</label>
											<SelectSearch
												id="tipoVisao"
												name="tipoVisao"
												options={this.state.tiposVisao.map(tipoVisao => ({ value: tipoVisao.codigo, label: tipoVisao.nome}))}
												onChange={this.handleTipoVisaoChange}
												value={this.state.tipoVisao}				
											/>
										</div>
									</div>
								</div>
							</div>
						}	
					<div className="row">
							{exibeComboOrgao &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="consumidora">Órgão Consumidor:</label>
											<SelectSearch
												id="orgao"
												name="orgao"
												options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome}))}
												onChange={this.handleOrgaoChange}
												value={this.state.orgao}				
											/>
										</div>
									</div>
								</div>
							}
							{exibeComboAplicacao &&
							<div className="col-md">
								<div className="field">
									<div className="input">
										
										<label htmlFor="consumidora">Aplicação:</label>
										{this.state.consumidoras.length > 0 &&
											<SelectSearch
												id="consumidora"
												name="consumidora"
												includeAllOption={true}
												allOptionName="Todas"
												options={this.state.consumidoras.map(consumidora => ({ value: consumidora.id, label: consumidora.nome}))}
												onChange={this.handleInputChange}
												value={this.state.consumidora}				
											/>
										}
										{this.state.carregandoConsumidoras === true && 
										<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}

										{this.state.carregandoConsumidoras === false && this.state.consumidoras.length === 0 && 'Não há aplicações para serem selecionadas.'}
									</div>
								</div>
							</div>
							}

							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{this.state.fornecedoras.length > 0 &&
											<SelectSearch
												id="fornecedora"
												name="fornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome}))}
												onChange={this.handleAPIChange}
												value={this.state.fornecedora}				
											/>
										}
										{this.state.carregandoFornecedoras === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}

										{this.state.carregandoFornecedoras === false && this.state.fornecedoras.length === 0 && 'Não há APIs para serem selecionadas.'}
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Período Inicial:</label>
										<DatePicker locale="pt_br" showTimeSelect dateFormat="dd/MM/yyyy HH:mm" timeFormat="HH:mm" selected={this.state.periodoInicial} onChange={data => {this.setState({periodoInicial: data})}} />
									</div>
								</div>
							</div>
						
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Período Final:</label>
										<DatePicker locale="pt_br" showTimeSelect dateFormat="dd/MM/yyyy HH:mm" timeFormat="HH:mm" selected={this.state.periodoFinal} onChange={data => {this.setState({periodoFinal: data})}} />
									</div>
								</div>
							</div>
						
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Códigos de Retorno:</label>
										<SelectSearch
											id="bilhetados"
											name="bilhetados"
											includeAllOption={true}
											options={[{ value: true, label: `Bilhetados ${codigosBilhetados}`}, { value: false, label: 'Não Bilhetados'}]}
											onChange={this.handleInputChange}
											value={this.state.bilhetados}				
										/>
										{this.state.carregandoCodigosBilhetados === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioAuditoriaGenericoPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>}
								{exibeBotoes === true &&	<button type="button" className="button is-secondary" onClick={this.mostraRelatorioAuditoriaGenericoCSV} disabled={!this.state.botoesHabilitados}>Relatório CSV</button>}
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
						<Resultado resultadoPesquisa={relatorioAuditoriaGenerico} pesquisaExecutada={pesquisaExecutada} exibeColunaCpfsCnpj={exibeColunaCpfsCnpj} onChangePage={this.executaPesquisa}/>
					</div>
				</div>
				
			);
		}

		validaFormulario(){
			let mensagens = [];
			const {orgao, fornecedora, periodoInicial, periodoFinal, tipoVisao } = this.state;
			const user = this.props.user;

			if(user && (user.isAdministrador === true || user.isMantenedor === true || (user.isFornecedor === true && tipoVisao === tipoVisaoFornecedor) || (user.isOperador === true && tipoVisao === tipoVisaoOperador)) && !orgao){
				mensagens.push({mensagem: "Órgão é obrigatório."})
			}
			if(!fornecedora){
				mensagens.push({mensagem: "API é obrigatório."})
			}

			if(!periodoInicial){
				mensagens.push({mensagem: "Período Inicial é obrigatório."})
			}
			if(!periodoFinal){
				mensagens.push({mensagem: "Período Final é obrigatório."})
			}

			if(periodoInicial && periodoFinal){
				const milisegundos = periodoFinal.getTime() - periodoInicial.getTime();
				if(milisegundos < 0){
					mensagens.push({mensagem: "O período inicial deve ser menor ou igual ao período final"});
				}
				if(milisegundos > 24*60*60*1000){
					mensagens.push({mensagem: "O período deve ser menor ou igual a 1 dia."});
				}
			}
			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		handleTipoVisaoChange(evento){
			const tipoVisao =  evento.target.value;
			const orgao = "";
			let consumidoras = [];
			let fornecedoras = [];
			if(tipoVisao === tipoVisaoConsumidor) {
				consumidoras = [...this.state.consumidorasOrgao];
			}

			this.setState({
				tipoVisao,
				consumidoras,
				consumidora: "",
				fornecedoras,
				fornecedora: "",
				orgao,
			});
			this.carregarOrgaos(tipoVisao);
			this.carregarFornecedoras(tipoVisao, orgao);
		}

		handleAPIChange(evento){
			const fornecedora =  evento.target.value;

			this.setState({
				fornecedora,
				bilhetados: true,
				codigosBilhetados: [],
			});
			
			this.carregarCodigosBilhetados(fornecedora);
		}

		carregarOrgaos(tipoVisao) {
			if(this.props.user.isAdministrador === false && this.props.user.isMantenedor === false
				&& (this.props.user.isFornecedor === false || tipoVisao !== tipoVisaoFornecedor)  
				&& (this.props.user.isOperador === false || tipoVisao !== tipoVisaoOperador))	{
				return;
			}

			api.get(`/api/orgao/consumidores/perfil-usuario?tipoVisao=${tipoVisao}`)
					.then(response => { this.setState({orgaos: response.data}) })
					.catch(erro => {
						console.log("Não foi possível recuperar órgãos consumidores " + erro)
						this.props.exibeMensagemErro("Erro durante o carregamento da página")
					});
		}

		carregarCodigosBilhetados(fornecedora) {
			if(!fornecedora) {
				return;
			}

			this.setState(
				{
					carregandoCodigosBilhetados : true
				}
			);

			api.get(`/api/aplicacao-fornecedora/codigos-sucesso/${fornecedora}`)
			.then(response => { 
				const codigosBilhetados = response.data;
				this.setState(
					{
						codigosBilhetados,
					}
				)
			 })
			.catch(erro => {
				console.log("Não foi possível recuperar as códigos bilhetados " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			})
			.finally(() => {
				this.setState({carregandoCodigosBilhetados : false});
			});
		}

		handleOrgaoChange(evento){
			const idOrgao =  evento.target.value;
			const idTipoVisao = this.state.tipoVisao;

			this.setState({
				consumidora: "",
				fornecedora: "",
				orgao: idOrgao,
			});
			
			this.carregarConsumidoras(idOrgao);
			this.carregarFornecedoras(idTipoVisao, idOrgao);
		}

		carregarConsumidoras(idOrgao) {
			if(idOrgao && idOrgao !== ""){
				this.setState({carregandoConsumidoras : true});
				api.get(`/api/aplicacao-consumidora/orgao/${idOrgao}`)
				.then(response => { 
					this.setState(
						{
							consumidoras: response.data,
							carregandoConsumidoras : false
						}
					);
				})
				.catch(erro => {
					this.setState({carregandoConsumidoras : false});
					console.log("Não foi possível recuperar as aplicações associadas ao órgão " + JSON.stringify(erro));
					this.props.exibeMensagemErro("Erro durante o carregamento das aplicações do órgão.")
				});
			}
		}

		carregarFornecedoras(idTipoVisao, idOrgao) {
			this.setState(
				{
					carregandoFornecedoras : true
				}
			);
			api.get(`/api/aplicacao-fornecedora/tipo-visao/${idTipoVisao}/orgao-consumidor?idOrgaoConsumidor=${idOrgao}`)
			.then(response => { 
				const fornecedoras = response.data;
				this.setState(
					{
						fornecedoras,
						carregandoFornecedoras : false,
					}
				)
			 })
			.catch(erro => {
				this.setState({carregandoFornecedoras : false});
				console.log("Não foi possível recuperar as aplicações fornecedoras " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				relatorioAuditoriaGenerico: {}
			}, () => {
				if (lastState) {
					const previousPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisa(previousPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}
			this.executaPesquisa(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisa(pagina){
			const {consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados } = this.state;
			const criterioPesquisa = this.getCriteriosPesquisa(consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados);
			const url = '/api/auditoria/generico';
			criterioPesquisa['pagina'] = pagina;
			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}
			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});
			api(options)
				.then(response => { 
					const relatorioAuditoriaGenerico = response.data; 
					const exibeColunaCpfsCnpj = relatorioAuditoriaGenerico.content.length > 0 && relatorioAuditoriaGenerico.content[0].cpfsCnpjConsultados;

					this.setState({
						relatorioAuditoriaGenerico,
						exibeColunaCpfsCnpj,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar o relatório de auditoria genérico. ", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		getCriteriosPesquisa(consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados){
			return {consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados};
		}

		mostraRelatorioAuditoriaGenericoPDF(e){
			this.mostraRelatorioAuditoriaGenerico(e, 'pdf')
		}

		mostraRelatorioAuditoriaGenericoCSV(e){
			this.mostraRelatorioAuditoriaGenerico(e, 'csv')
		}

		mostraRelatorioAuditoriaGenerico(e, tipo){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const {consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados } = this.state;
			const criterioPesquisa = this.getCriteriosPesquisa(consumidora, fornecedora, orgao, periodoInicial, periodoFinal, tipoVisao, bilhetados);
			const url = `/api/auditoria/generico/${tipo}`;
			const options = {
				method: 'post',
				url,
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), `RelatorioAuditoriaGenerico.${tipo}`);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de auditoria genérico';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState({botoesHabilitados : true});
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			let tipoVisao = tipoVisaoConsumidor;

			if(this.props.user.isFornecedor === true){
				tipoVisao = tipoVisaoFornecedor;
			} 
			if(this.props.user.isOperador === true){
				tipoVisao = tipoVisaoOperador;
			}
			const orgao = '';
			this.setState({
				orgao,
				consumidoras: this.props.user.isAdministrador || this.props.user.isMantenedor ? [] : [...this.state.consumidorasOrgao],
				consumidora: '',
				fornecedora: '',
				periodoInicial: '',
				periodoFinal: '',
				tipoVisao,
				exibeColunaCpfsCnpj: '',
				codigosBilhetados: [],
				bilhetados: true,
				relatorioAuditoriaGenerico: {},
				pesquisaExecutada : false,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
			this.carregarOrgaos(tipoVisao);
			this.carregarFornecedoras(tipoVisao, orgao);
		}
	}

) // redux
); // router